module.exports = "<section class=\"sequencer_node_inspector\">\n\n</section>"